module.exports = __webpack_public_path__ + "img/back_rise.7dffdf40.png";